(() => {
    let ingredientsSwiper;

    const init = () => {
        document.querySelectorAll('.ingredients-section').forEach((section) => {
            const swiperEl = section.querySelector('.swiper');
            const nextEl = section.querySelector('.next-button');
            const prevEl = section.querySelector('.prev-button');

            ingredientsSwiper = new Swiper(swiperEl, {
                slidesPerView: 4,
                spaceBetween: 10,
                breakpointsBase: 'window',
                observer: true,
                observeParents: true,
                updateOnWindowResize: true,

                breakpoints: {
                    0: { slidesPerView: 1.15, spaceBetween: 12 },
                    640: { slidesPerView: 2, spaceBetween: 16 },
                    900: { slidesPerView: 3, spaceBetween: 16 },
                    1200: { slidesPerView: 4, spaceBetween: 16 },
                },

                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
            });
        });

        window.addEventListener('resize', () => {
            if (ingredientsSwiper) {
                ingredientsSwiper.update();
                ingredientsSwiper.navigation?.update();
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

